var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Your DDDI Application Has Been Saved")]),_c('p',[_vm._v("\n    Your DDDI application has been saved.\n  ")])])
}]

export { render, staticRenderFns }